<template>
    <vx-modal :visible="props.visible"
        @update:visible="emit('update:visible', $event)"
        :padding="false"
        size="md">
        <template v-slot:header>
            <div class="px-6 pt-6">
                <slot name="header">
                    Preview Message
                </slot>
            </div>
        </template>

        <template v-if="$slots.subheader" v-slot:subheader>
            <div class="px-6">
                <slot name="subheader"></slot>
            </div>
        </template>

        <div class="p-6">
            <div
                class="p-4 whitespace-pre-line bg-white shadow text-slate-700 text-sm font-normal rounded-[16px] rounded-bl overflow-y-auto">
                <slot name="body">
                    {{ props.message.body }}
                </slot>
            </div>
            <div v-if="props.message.mediaUrl"
                class="mt-2 p-4 bg-white shadow rounded-[16px] rounded-bl max-w-[208px] max-h-[500px]">
                <img :src="props.message.mediaUrl"
                    class="w-full block object-cover rounded rounded-b-[4px]" />
            </div>
        </div>

        <template v-if="$slots.footer"
            v-slot:footer>
            <div class="flex flex-col-reverse gap-4 lg:flex-row">
                <slot name="footer"></slot>
            </div>
        </template>
    </vx-modal>
</template>

<script setup>
import { VxModal } from '@voxie/frontend-components';

const props = defineProps({
    visible: Boolean,
    message: {
        type: Object,
        required: true,
        default: () => ({})
    },
});

const emit = defineEmits(['update:visible']);
</script>
